/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const wearables = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="#000"
      d="M6.517 12.136a.75.75 0 1 0-1.5 0h1.5Zm4.455 0a.75.75 0 1 0-1.5 0h1.5ZM9.96 1.273l-.543.518.543-.518Zm-.49 2.59a.75.75 0 0 0 1.5 0h-1.5Zm-4.454 0a.75.75 0 0 0 1.5 0h-1.5Zm1.011-2.59.543.518-.543-.518ZM9.331 14.25H6.658v1.5h2.673v-1.5Zm-2.673 0a.121.121 0 0 1-.087-.041l-1.085 1.036c.304.319.725.505 1.172.505v-1.5Zm-.087-.041a.207.207 0 0 1-.054-.142h-1.5c0 .435.165.86.469 1.178l1.085-1.036Zm-.054-.142v-1.93h-1.5v1.93h1.5Zm2.955-1.93v1.93h1.5v-1.93h-1.5Zm0 1.93c0 .06-.023.11-.054.142l1.085 1.036c.304-.319.469-.743.469-1.178h-1.5Zm-.054.142a.121.121 0 0 1-.087.041v1.5c.447 0 .868-.186 1.172-.505l-1.085-1.036ZM6.658 1.75h2.673V.25H6.658v1.5Zm2.673 0c.026 0 .058.01.087.041L10.503.756A1.621 1.621 0 0 0 9.331.25v1.5Zm.087.041a.21.21 0 0 1 .054.142h1.5c0-.435-.165-.86-.469-1.177L9.418 1.79Zm.054.142v1.93h1.5v-1.93h-1.5Zm-2.955 1.93v-1.93h-1.5v1.93h1.5Zm0-1.93c0-.06.023-.11.054-.142L5.486.756a1.706 1.706 0 0 0-.469 1.177h1.5Zm.054-.142a.121.121 0 0 1 .087-.041V.25a1.62 1.62 0 0 0-1.172.506L6.57 1.79ZM11.699 8a3.705 3.705 0 0 1-3.704 3.704v1.5A5.205 5.205 0 0 0 13.199 8h-1.5Zm-3.704 3.704A3.704 3.704 0 0 1 4.29 8h-1.5a5.204 5.204 0 0 0 5.205 5.204v-1.5ZM4.29 8a3.705 3.705 0 0 1 3.705-3.705v-1.5A5.205 5.205 0 0 0 2.79 8h1.5Zm3.705-3.705A3.705 3.705 0 0 1 11.699 8h1.5a5.205 5.205 0 0 0-5.204-5.205v1.5Z"
    />
  </svg>
)
export default wearables
